import { TAuthority } from './authority';
import { ERole } from './role';

import {
  LoginUserAcquirerResponse,
  LoginUserCompanyResponse,
  LoginUserIssuerResponse,
  LoginUserShopResponse,
  LoginUserWalletServiceResponse,
  LoginUserTenantResponse,
} from '@/repositories/generated';

export type LoginUserGiftIssuerResponse = {
  id: string;
  name: string;
};

export type LoginUserResponse = {
  id: string;
  loginId: string;
  role: {
    name: string;
    code: string;
  };
  authorities: TAuthority[];
  acquirer?: LoginUserAcquirerResponse;
  issuer?: LoginUserIssuerResponse;
  company?: LoginUserCompanyResponse;
  shop?: LoginUserShopResponse;
  walletService?: LoginUserWalletServiceResponse;
  tenant?: LoginUserTenantResponse;
  giftIssuer?: LoginUserGiftIssuerResponse;
};

export const systemManager: LoginUserResponse = {
  id: '1',
  loginId: 'system.manager',
  role: {
    name: 'システム管理者',
    code: ERole.SYSTEM_MANAGER,
  },
  authorities: [
    'TRANSACTIONS',
    'REVERT_TRANSACTION',
    'WALLET_SERVICES',
    'COMPANIES',
    'DOWNLOAD_COMPANIES',
    'CREATE_COMPANIES',
    'EDIT_BASIC_INFO_COMPANIES',
    'EDIT_COMPANIES',
    'SHOPS',
    'DOWNLOAD_SHOPS',
    'CREATE_SHOPS',
    'EDIT_SHOPS',
    'TERMINALS',
    'DOWNLOAD_TERMINALS',
    'EDIT_TERMINALS',
    'SETUP_TERMINALS',
    'RESET_TERMINAL_PASSWORD',
    'APP_USERS',
    'EDIT_APP_USERS',
    'RESET_APP_USERS',
    'LOGIN_LOCK_APP_USERS',
    'VALID_BANK_ACCOUNT',
    'WITHDRAWAL_APP_USERS',
    'BALANCE_ADJUSTMENT',
    'ADMIN_USERS',
    'DOWNLOAD_ADMIN_USERS',
    'EDIT_ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD',
    'RESERVE_BULK_GRANTS',
    'BULK_GRANTS',
    'MASTER_UPLOADS',
    'FILE_UPLOADS',
    'FILE_DOWNLOADS',
    'TEMP_USER',
    'BANKPAY_TRANSACTIONS',
    'DOWNLOAD_BANKPAY_TRANSACTIONS',
    'AGGREGATIONS',
    'DOWNLOAD_AGGREGATIONS',
    'RESERVE_PREPAID_TOTAL_AGGREGATIONS',
    'RESERVE_CHARGE_AGGREGATIONS',
    'RESERVE_SETTLEMENT_AGGREGATIONS',
    'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
    'RESERVE_CAMPAIGN_AGGREGATIONS',
    'RESERVE_BULK_GRANT_AGGREGATIONS',
    'RESERVE_UNUSED_BALANCE_AGGREGATIONS',
    'CAMPAIGNS',
    'EDIT_CAMPAIGNS',
    'DOWNLOAD_TRANSACTIONS',
    'DOWNLOAD_APP_USERS',
    'GIFTS',
    'PHYSICAL_PREPAID_CARDS',
    'EDIT_PHYSICAL_PREPAID_CARDS',
    'DOWNLOAD_PHYSICAL_PREPAID_CARDS',
  ],
  acquirer: undefined,
  issuer: undefined,
  company: undefined,
  shop: undefined,
  walletService: undefined,
  tenant: undefined,
};

export const systemStaff: LoginUserResponse = {
  id: '1',
  loginId: 'system.staff',
  role: {
    name: 'システム担当者',
    code: ERole.SYSTEM_STAFF,
  },
  authorities: [
    'TRANSACTIONS',
    'WALLET_SERVICES',
    'COMPANIES',
    'DOWNLOAD_COMPANIES',
    'SHOPS',
    'DOWNLOAD_SHOPS',
    'TERMINALS',
    'DOWNLOAD_TERMINALS',
    'SETUP_TERMINALS',
    'APP_USERS',
    'ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD_FOR_STAFF',
    'BULK_GRANTS',
    'RESERVE_BULK_GRANTS',
    'BANKPAY_TRANSACTIONS',
    'DOWNLOAD_BANKPAY_TRANSACTIONS',
    'AGGREGATIONS',
    'DOWNLOAD_AGGREGATIONS',
    'RESERVE_PREPAID_TOTAL_AGGREGATIONS',
    'RESERVE_CHARGE_AGGREGATIONS',
    'RESERVE_SETTLEMENT_AGGREGATIONS',
    'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
    'RESERVE_CAMPAIGN_AGGREGATIONS',
    'RESERVE_BULK_GRANT_AGGREGATIONS',
    'RESERVE_UNUSED_BALANCE_AGGREGATIONS',
    'CAMPAIGNS',
    'EDIT_CAMPAIGNS',
    'DOWNLOAD_TRANSACTIONS',
    'DOWNLOAD_APP_USERS',
    'GIFTS',
    'PHYSICAL_PREPAID_CARDS',
    'DOWNLOAD_PHYSICAL_PREPAID_CARDS',
  ],
  acquirer: undefined,
  issuer: undefined,
  company: undefined,
  shop: undefined,
  walletService: undefined,
  tenant: undefined,
};

export const tenantManager: LoginUserResponse = {
  id: '1',
  loginId: 'tenant.manager',
  role: {
    name: 'テナント管理者',
    code: ERole.TENANT_MANAGER,
  },
  authorities: [
    'TRANSACTIONS',
    'REVERT_TRANSACTION',
    'WALLET_SERVICES',
    'COMPANIES',
    'DOWNLOAD_COMPANIES',
    'CREATE_COMPANIES',
    'EDIT_BASIC_INFO_COMPANIES',
    'EDIT_COMPANIES',
    'SHOPS',
    'DOWNLOAD_SHOPS',
    'CREATE_SHOPS',
    'EDIT_SHOPS',
    'TERMINALS',
    'DOWNLOAD_TERMINALS',
    'EDIT_TERMINALS',
    'SETUP_TERMINALS',
    'RESET_TERMINAL_PASSWORD',
    'APP_USERS',
    'EDIT_APP_USERS',
    'RESET_APP_USERS',
    'LOGIN_LOCK_APP_USERS',
    'VALID_BANK_ACCOUNT',
    'WITHDRAWAL_APP_USERS',
    'BALANCE_ADJUSTMENT',
    'ADMIN_USERS',
    'DOWNLOAD_ADMIN_USERS',
    'EDIT_ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD',
    'RESERVE_BULK_GRANTS',
    'BULK_GRANTS',
    'MASTER_UPLOADS',
    'FILE_UPLOADS',
    'FILE_DOWNLOADS',
    'TEMP_USER',
    'BANKPAY_TRANSACTIONS',
    'DOWNLOAD_BANKPAY_TRANSACTIONS',
    'AGGREGATIONS',
    'DOWNLOAD_AGGREGATIONS',
    'RESERVE_PREPAID_TOTAL_AGGREGATIONS',
    'RESERVE_CHARGE_AGGREGATIONS',
    'RESERVE_SETTLEMENT_AGGREGATIONS',
    'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
    'RESERVE_CAMPAIGN_AGGREGATIONS',
    'RESERVE_BULK_GRANT_AGGREGATIONS',
    'RESERVE_UNUSED_BALANCE_AGGREGATIONS',
    'CAMPAIGNS',
    'EDIT_CAMPAIGNS',
    'DOWNLOAD_TRANSACTIONS',
    'DOWNLOAD_APP_USERS',
    'MASTER_UPLOADS',
    'GIFTS',
    'PHYSICAL_PREPAID_CARDS',
    'EDIT_PHYSICAL_PREPAID_CARDS',
    'DOWNLOAD_PHYSICAL_PREPAID_CARDS',
  ],
  acquirer: undefined,
  issuer: undefined,
  company: undefined,
  shop: undefined,
  walletService: undefined,
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const tenantStaff: LoginUserResponse = {
  id: '1',
  loginId: 'tenant.staff',
  role: {
    name: 'テナント担当者',
    code: ERole.TENANT_STAFF,
  },
  authorities: [
    'TRANSACTIONS',
    'WALLET_SERVICES',
    'COMPANIES',
    'DOWNLOAD_COMPANIES',
    'SHOPS',
    'DOWNLOAD_SHOPS',
    'TERMINALS',
    'DOWNLOAD_TERMINALS',
    'SETUP_TERMINALS',
    'APP_USERS',
    'ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD_FOR_STAFF',
    'BULK_GRANTS',
    'RESERVE_BULK_GRANTS',
    'BANKPAY_TRANSACTIONS',
    'DOWNLOAD_BANKPAY_TRANSACTIONS',
    'AGGREGATIONS',
    'DOWNLOAD_AGGREGATIONS',
    'RESERVE_PREPAID_TOTAL_AGGREGATIONS',
    'RESERVE_CHARGE_AGGREGATIONS',
    'RESERVE_SETTLEMENT_AGGREGATIONS',
    'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
    'RESERVE_CAMPAIGN_AGGREGATIONS',
    'RESERVE_BULK_GRANT_AGGREGATIONS',
    'RESERVE_UNUSED_BALANCE_AGGREGATIONS',
    'CAMPAIGNS',
    'EDIT_CAMPAIGNS',
    'DOWNLOAD_TRANSACTIONS',
    'DOWNLOAD_APP_USERS',
    'GIFTS',
    'PHYSICAL_PREPAID_CARDS',
    'DOWNLOAD_PHYSICAL_PREPAID_CARDS',
  ],
  acquirer: undefined,
  issuer: undefined,
  company: undefined,
  shop: undefined,
  walletService: undefined,
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const valueIssuerManager: LoginUserResponse = {
  id: '1',
  loginId: 'valueIssuer.manager',
  role: {
    name: 'バリューイシュア管理者',
    code: ERole.VALUE_ISSUER_MANAGER,
  },
  authorities: [
    'TRANSACTIONS',
    'REVERT_TRANSACTION',
    'WALLET_SERVICES',
    'SHOPS',
    'DOWNLOAD_SHOPS',
    'TERMINALS',
    'DOWNLOAD_TERMINALS',
    'APP_USERS',
    'EDIT_APP_USERS',
    'RESET_APP_USERS',
    'LOGIN_LOCK_APP_USERS',
    'VALID_BANK_ACCOUNT',
    'WITHDRAWAL_APP_USERS',
    'BALANCE_ADJUSTMENT',
    'ADMIN_USERS',
    'DOWNLOAD_ADMIN_USERS',
    'EDIT_ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD',
    'RESERVE_BULK_GRANTS',
    'BULK_GRANTS',
    'MASTER_UPLOADS',
    'FILE_DOWNLOADS',
    'TEMP_USER',
    'BANKPAY_TRANSACTIONS',
    'DOWNLOAD_BANKPAY_TRANSACTIONS',
    'AGGREGATIONS',
    'DOWNLOAD_AGGREGATIONS',
    'RESERVE_PREPAID_TOTAL_AGGREGATIONS',
    'RESERVE_CHARGE_AGGREGATIONS',
    'RESERVE_SETTLEMENT_AGGREGATIONS',
    'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
    'RESERVE_CAMPAIGN_AGGREGATIONS',
    'RESERVE_BULK_GRANT_AGGREGATIONS',
    'RESERVE_UNUSED_BALANCE_AGGREGATIONS',
    'CAMPAIGNS',
    'EDIT_CAMPAIGNS',
    'DOWNLOAD_TRANSACTIONS',
    'DOWNLOAD_APP_USERS',
    'MASTER_UPLOADS',
    'GIFTS',
    'PHYSICAL_PREPAID_CARDS',
    'EDIT_PHYSICAL_PREPAID_CARDS',
    'DOWNLOAD_PHYSICAL_PREPAID_CARDS',
  ],
  acquirer: undefined,
  issuer: {
    id: '32',
    name: 'モックイシュア３',
  },
  company: undefined,
  shop: undefined,
  walletService: undefined,
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const valueIssuerStaff: LoginUserResponse = {
  id: '1',
  loginId: 'valueIssuer.staff',
  role: {
    name: 'バリューイシュア担当者',
    code: ERole.VALUE_ISSUER_STAFF,
  },
  authorities: [
    'TRANSACTIONS',
    'WALLET_SERVICES',
    'SHOPS',
    'TERMINALS',
    'APP_USERS',
    'EDIT_APP_USERS',
    'RESET_APP_USERS',
    'LOGIN_LOCK_APP_USERS',
    'ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD_FOR_STAFF',
    'BULK_GRANTS',
    'BANKPAY_TRANSACTIONS',
    'CAMPAIGNS',
    'GIFTS',
    'PHYSICAL_PREPAID_CARDS',
    'EDIT_PHYSICAL_PREPAID_CARDS',
  ],
  acquirer: undefined,
  issuer: {
    id: '42',
    name: 'モックイシュア４',
  },
  company: undefined,
  shop: undefined,
  walletService: undefined,
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const walletServiceManager: LoginUserResponse = {
  id: '1',
  loginId: 'walletService.manager',
  role: {
    name: 'ウォレットサービス管理者',
    code: ERole.WALLET_SERVICE_MANAGER,
  },
  authorities: [
    'TRANSACTIONS',
    'REVERT_TRANSACTION',
    'WALLET_SERVICES',
    'SHOPS',
    'DOWNLOAD_SHOPS',
    'TERMINALS',
    'DOWNLOAD_TERMINALS',
    'APP_USERS',
    'EDIT_APP_USERS',
    'RESET_APP_USERS',
    'RESET_APP_USERS',
    'LOGIN_LOCK_APP_USERS',
    'VALID_BANK_ACCOUNT',
    'WITHDRAWAL_APP_USERS',
    'BALANCE_ADJUSTMENT',
    'ADMIN_USERS',
    'DOWNLOAD_ADMIN_USERS',
    'EDIT_ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD',
    'MASTER_UPLOADS',
    'RESERVE_BULK_GRANTS',
    'BULK_GRANTS',
    'TEMP_USER',
    'BANKPAY_TRANSACTIONS',
    'DOWNLOAD_BANKPAY_TRANSACTIONS',
    'AGGREGATIONS',
    'DOWNLOAD_AGGREGATIONS',
    'RESERVE_PREPAID_TOTAL_AGGREGATIONS',
    'RESERVE_CHARGE_AGGREGATIONS',
    'RESERVE_SETTLEMENT_AGGREGATIONS',
    'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
    'RESERVE_CAMPAIGN_AGGREGATIONS',
    'RESERVE_BULK_GRANT_AGGREGATIONS',
    'RESERVE_UNUSED_BALANCE_AGGREGATIONS',
    'CAMPAIGNS',
    'EDIT_CAMPAIGNS',
    'DOWNLOAD_TRANSACTIONS',
    'DOWNLOAD_APP_USERS',
    'MASTER_UPLOADS',
    'GIFTS',
    'PHYSICAL_PREPAID_CARDS',
    'EDIT_PHYSICAL_PREPAID_CARDS',
    'DOWNLOAD_PHYSICAL_PREPAID_CARDS',
  ],
  acquirer: undefined,
  issuer: {
    id: '52',
    name: 'モックイシュア５',
  },
  company: undefined,
  shop: undefined,
  walletService: {
    id: '55',
    name: 'モックウォレットサービス５',
  },
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const walletServiceStaff: LoginUserResponse = {
  id: '1',
  loginId: 'walletService.staff',
  role: {
    name: 'ウォレットサービス担当者',
    code: ERole.WALLET_SERVICE_STAFF,
  },
  authorities: [
    'TRANSACTIONS',
    'WALLET_SERVICES',
    'SHOPS',
    'TERMINALS',
    'APP_USERS',
    'EDIT_APP_USERS',
    'RESET_APP_USERS',
    'LOGIN_LOCK_APP_USERS',
    'ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD_FOR_STAFF',
    'BULK_GRANTS',
    'BANKPAY_TRANSACTIONS',
    'CAMPAIGNS',
    'GIFTS',
    'PHYSICAL_PREPAID_CARDS',
    'EDIT_PHYSICAL_PREPAID_CARDS',
  ],
  acquirer: undefined,
  issuer: {
    id: '62',
    name: 'モックイシュア６',
  },
  company: undefined,
  shop: undefined,
  walletService: {
    id: '65',
    name: 'モックウォレットサービス６',
  },
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const acquirerManager: LoginUserResponse = {
  id: '1',
  loginId: 'acquirer.manager',
  role: {
    name: 'アクワイアラ管理者',
    code: ERole.ACQUIRER_MANAGER,
  },
  authorities: [
    'TRANSACTIONS',
    'REVERT_TRANSACTION',
    'COMPANIES',
    'DOWNLOAD_COMPANIES',
    'CREATE_COMPANIES',
    'EDIT_BASIC_INFO_COMPANIES',
    'EDIT_COMPANIES',
    'SHOPS',
    'DOWNLOAD_SHOPS',
    'CREATE_SHOPS',
    'EDIT_SHOPS',
    'TERMINALS',
    'EDIT_TERMINALS',
    'DOWNLOAD_TERMINALS',
    'SETUP_TERMINALS',
    'RESET_TERMINAL_PASSWORD',
    'ADMIN_USERS',
    'DOWNLOAD_ADMIN_USERS',
    'EDIT_ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD',
    'MASTER_UPLOADS',
    'FILE_UPLOADS',
    'FILE_DOWNLOADS',
    'AGGREGATIONS',
    'DOWNLOAD_AGGREGATIONS',
    'RESERVE_CHARGE_AGGREGATIONS',
    'RESERVE_SETTLEMENT_AGGREGATIONS',
    'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
    'RESERVE_CAMPAIGN_AGGREGATIONS',
    'DOWNLOAD_TRANSACTIONS',
  ],
  acquirer: {
    id: '71',
    name: 'モックアクワイアラ７',
    externalLinkName1: '外部リンク表示名1',
    externalLinkUrl1: 'https://example.com',
    externalLinkName2: '外部リンク表示名2',
    externalLinkUrl2: 'https://example.org',
  },
  issuer: undefined,
  company: undefined,
  shop: undefined,
  walletService: undefined,
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const acquirerStaff: LoginUserResponse = {
  id: '1',
  loginId: 'acquirer.staff',
  role: {
    name: 'アクワイアラ担当者',
    code: ERole.ACQUIRER_STAFF,
  },
  authorities: [
    'TRANSACTIONS',
    'COMPANIES',
    'SHOPS',
    'TERMINALS',
    'ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD_FOR_STAFF',
  ],
  acquirer: {
    id: '81',
    name: 'モックアクワイアラ８',
    externalLinkName1: '外部リンク表示名1',
    externalLinkUrl1: 'https://example.com',
    externalLinkName2: '外部リンク表示名2',
    externalLinkUrl2: 'https://example.org',
  },
  issuer: undefined,
  company: undefined,
  shop: undefined,
  walletService: undefined,
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const premiumGiftManager: LoginUserResponse = {
  id: '1',
  loginId: 'premiumGift.manager',
  role: {
    name: 'プレミアム商品券事務局管理者',
    code: ERole.PREMIUM_GIFT_MANAGER,
  },
  authorities: [
    'TRANSACTIONS',
    'REVERT_TRANSACTION',
    'WALLET_SERVICES',
    'COMPANIES',
    'CREATE_COMPANIES',
    'EDIT_BASIC_INFO_COMPANIES',
    'EDIT_COMPANIES',
    'SHOPS',
    'CREATE_SHOPS',
    'EDIT_SHOPS',
    'TERMINALS',
    'EDIT_TERMINALS',
    'RESET_TERMINAL_PASSWORD',
    'APP_USERS',
    'EDIT_APP_USERS',
    'RESET_APP_USERS',
    'ADMIN_USERS',
    'DOWNLOAD_ADMIN_USERS',
    'EDIT_ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD',
    'MASTER_UPLOADS',
    'FILE_UPLOADS',
    'FILE_DOWNLOADS',
    'TEMP_USER',
    'SHOP_CHARGE',
    'PREMIUM_GIFTS',
    'POLICY',
    'BANKPAY_TRANSACTIONS',
  ],
  acquirer: {
    id: '91',
    name: 'モックアクワイアラ９',
    externalLinkName1: '外部リンク表示名1',
    externalLinkUrl1: 'https://example.com',
    externalLinkName2: '外部リンク表示名2',
    externalLinkUrl2: 'https://example.org',
  },
  issuer: {
    id: '92',
    name: 'モックイシュア９',
  },
  company: {
    id: '93',
    name: 'モック企業９',
  },
  shop: {
    id: '94',
    name: 'モック店舗９',
  },
  walletService: {
    id: '95',
    name: 'モックウォレットサービス９',
  },
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const premiumGiftStaff: LoginUserResponse = {
  id: '1',
  loginId: 'premiumGift.staff',
  role: {
    name: 'プレミアム商品券事務局担当者',
    code: ERole.PREMIUM_GIFT_STAFF,
  },
  authorities: [
    'TRANSACTIONS',
    'WALLET_SERVICES',
    'COMPANIES',
    'SHOPS',
    'TERMINALS',
    'ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD_FOR_STAFF',
    'SHOP_CHARGE',
    'PREMIUM_GIFTS',
    'BANKPAY_TRANSACTIONS',
  ],
  acquirer: {
    id: '101',
    name: 'モックアクワイアラ１０',
    externalLinkName1: '外部リンク表示名1',
    externalLinkUrl1: 'https://example.com',
    externalLinkName2: '外部リンク表示名2',
    externalLinkUrl2: 'https://example.org',
  },
  issuer: {
    id: '102',
    name: 'モックイシュア１０',
  },
  company: {
    id: '103',
    name: 'モック企業１０',
  },
  shop: {
    id: '104',
    name: 'モック店舗１０',
  },
  walletService: {
    id: '105',
    name: 'モックウォレットサービス１０',
  },
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const companyManager: LoginUserResponse = {
  id: '1',
  loginId: 'company.manager',
  role: {
    name: '企業管理者',
    code: ERole.COMPANY_MANAGER,
  },
  authorities: [
    'TRANSACTIONS',
    'REVERT_TRANSACTION',
    'COMPANIES',
    'DOWNLOAD_COMPANIES',
    'SHOPS',
    'EDIT_SHOPS',
    'DOWNLOAD_SHOPS',
    'TERMINALS',
    'DOWNLOAD_TERMINALS',
    'RESET_TERMINAL_PASSWORD',
    'ADMIN_USERS',
    'DOWNLOAD_ADMIN_USERS',
    'EDIT_ADMIN_USERS',
    'SETUP_TERMINALS',
    'RESET_ADMIN_USER_PASSWORD',
    'POLICY',
    'AGGREGATIONS',
    'DOWNLOAD_AGGREGATIONS',
    'RESERVE_CHARGE_AGGREGATIONS',
    'RESERVE_SETTLEMENT_AGGREGATIONS',
    'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
    'RESERVE_CAMPAIGN_AGGREGATIONS',
    'DOWNLOAD_TRANSACTIONS',
    'MASTER_UPLOADS',
  ],
  acquirer: {
    id: '111',
    name: 'モックアクワイアラ１１',
    externalLinkName1: '外部リンク表示名1',
    externalLinkUrl1: 'https://example.com',
    externalLinkName2: '外部リンク表示名2',
    externalLinkUrl2: 'https://example.org',
  },
  issuer: undefined,
  company: {
    id: '113',
    name: 'モック企業１１',
  },
  shop: undefined,
  walletService: undefined,
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const companyStaff: LoginUserResponse = {
  id: '1',
  loginId: 'company.staff',
  role: {
    name: '企業担当者',
    code: ERole.COMPANY_STAFF,
  },
  authorities: [
    'TRANSACTIONS',
    'COMPANIES',
    'SHOPS',
    'TERMINALS',
    'RESET_ADMIN_USER_PASSWORD_FOR_STAFF',
    'POLICY',
  ],
  acquirer: {
    id: '121',
    name: 'モックアクワイアラ１２',
    externalLinkName1: '外部リンク表示名1',
    externalLinkUrl1: 'https://example.com',
    externalLinkName2: '外部リンク表示名2',
    externalLinkUrl2: 'https://example.org',
  },
  issuer: undefined,
  company: {
    id: '123',
    name: 'モック企業１２',
  },
  shop: undefined,
  walletService: undefined,
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const shopManager: LoginUserResponse = {
  id: '1',
  loginId: 'shop.manager',
  role: {
    name: '店舗管理者',
    code: ERole.SHOP_MANAGER,
  },
  authorities: [
    'TRANSACTIONS',
    'REVERT_TRANSACTION',
    'SHOPS',
    'DOWNLOAD_SHOPS',
    'EDIT_SHOPS',
    'TERMINALS',
    'DOWNLOAD_TERMINALS',
    'RESET_TERMINAL_PASSWORD',
    'ADMIN_USERS',
    'DOWNLOAD_ADMIN_USERS',
    'EDIT_ADMIN_USERS',
    'SETUP_TERMINALS',
    'RESET_ADMIN_USER_PASSWORD',
    'LOGIN_SHOP_APP',
    'SETTLEMENTS',
    'POLICY',
    'AGGREGATIONS',
    'DOWNLOAD_AGGREGATIONS',
    'RESERVE_CHARGE_AGGREGATIONS',
    'RESERVE_SETTLEMENT_AGGREGATIONS',
    'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
    'RESERVE_CAMPAIGN_AGGREGATIONS',
    'DOWNLOAD_TRANSACTIONS',
    'MASTER_UPLOADS',
  ],
  acquirer: {
    id: '131',
    name: 'モックアクワイアラ１３',
    externalLinkName1: '外部リンク表示名1',
    externalLinkUrl1: 'https://example.com',
    externalLinkName2: '外部リンク表示名2',
    externalLinkUrl2: 'https://example.org',
  },
  issuer: undefined,
  company: {
    id: '133',
    name: 'モック企業１３',
  },
  shop: {
    id: '134',
    name: 'モック店舗１３',
  },
  walletService: undefined,
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const shopStaff: LoginUserResponse = {
  id: '1',
  loginId: 'shop.staff',
  role: {
    name: '店舗担当者',
    code: ERole.SHOP_STAFF,
  },
  authorities: [
    'TRANSACTIONS',
    'SHOPS',
    'TERMINALS',
    'RESET_ADMIN_USER_PASSWORD_FOR_STAFF',
    'LOGIN_SHOP_APP',
    'SETTLEMENTS',
    'POLICY',
  ],
  acquirer: {
    id: '141',
    name: 'モックアクワイアラ１４',
    externalLinkName1: '外部リンク表示名1',
    externalLinkUrl1: 'https://example.com',
    externalLinkName2: '外部リンク表示名2',
    externalLinkUrl2: 'https://example.org',
  },
  issuer: undefined,
  company: {
    id: '143',
    name: 'モック企業１４',
  },
  shop: {
    id: '144',
    name: 'モック店舗１４',
  },
  walletService: undefined,
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};

export const giftIssuerManager: LoginUserResponse = {
  id: '1',
  loginId: 'giftIssuer.manager',
  role: {
    name: '商品券管理者',
    code: ERole.GIFT_ISSUER_MANAGER,
  },
  authorities: [
    'TRANSACTIONS',
    'SHOPS',
    'ADMIN_USERS',
    'EDIT_ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD',
    'MASTER_UPLOADS',
    'FILE_DOWNLOADS',
    'DOWNLOAD_TRANSACTIONS',
    'DOWNLOAD_ADMIN_USERS',
    'GIFTS',
  ],
  acquirer: undefined,
  issuer: undefined,
  company: undefined,
  shop: undefined,
  walletService: {
    id: '165',
    name: 'モックウォレットサービス１６',
  },
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
  giftIssuer: {
    id: '161',
    name: 'モック商品券事業者１６',
  },
};

export const giftIssuerStaff: LoginUserResponse = {
  id: '1',
  loginId: 'giftIssuer.staff',
  role: {
    name: '商品券担当者',
    code: ERole.GIFT_ISSUER_STAFF,
  },
  authorities: [
    'TRANSACTIONS',
    'SHOPS',
    'GIFTS',
  ],
  acquirer: undefined,
  issuer: undefined,
  company: undefined,
  shop: undefined,
  walletService: {
    id: '175',
    name: 'モックウォレットサービス１７',
  },
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
  giftIssuer: {
    id: '171',
    name: 'モック商品券事業者１７',
  },
};

export const premiumGiftShopManager: LoginUserResponse = {
  id: '1',
  loginId: 'premiumGiftShop.manager',
  role: {
    name: 'プレミアム商品券店舗管理者',
    code: ERole.PREMIUM_GIFT_SHOP_MANAGER,
  },
  authorities: [
    'TRANSACTIONS',
    'REVERT_TRANSACTION',
    'SHOPS',
    'TERMINALS',
    'APP_USERS',
    'ADMIN_USERS',
    'DOWNLOAD_ADMIN_USERS',
    'EDIT_ADMIN_USERS',
    'RESET_ADMIN_USER_PASSWORD',
    'POLICY',
  ],
  acquirer: {
    id: '151',
    name: 'モックアクワイアラ１５',
    externalLinkName1: '外部リンク表示名1',
    externalLinkUrl1: 'https://example.com',
    externalLinkName2: '外部リンク表示名2',
    externalLinkUrl2: 'https://example.org',
  },
  issuer: {
    id: '152',
    name: 'モックイシュア１５',
  },
  company: {
    id: '153',
    name: 'モック企業１５',
  },
  shop: {
    id: '154',
    name: 'モック店舗１５',
  },
  walletService: {
    id: '155',
    name: 'モックウォレットサービス１５',
  },
  tenant: {
    id: '1',
    name: 'モックテナント1',
  },
};
